import { useEffect, useState } from "react";
import { serviceCheckBlockedBulk, serviceCheckPendingBulk } from "services/contactBlock";

export function useContactBlockStatus(phoneNumber, token) {
  const [isBlocked, setIsBlocked] = useState(false);
  const [isPending, setIsPending] = useState(false);

  useEffect(() => {
    if (!phoneNumber || !token) {
      setIsBlocked(false);
      setIsPending(false);
      return;
    }

    let isCancelled = false;

    serviceCheckBlockedBulk(token, [phoneNumber]).then((resp) => {
      if (!isCancelled && resp.status === 200) {
        setIsBlocked(!!resp.data[phoneNumber]);
      }
    });

    serviceCheckPendingBulk(token, [phoneNumber]).then((resp) => {
      if (!isCancelled && resp.status === 200) {
        setIsPending(!!resp.data[phoneNumber]);
      }
    });

    return () => {
      isCancelled = true;
    };
  }, [phoneNumber, token]);

  // Call right after a submit succeeds so the button reacts immediately,
  // without waiting on a refetch.
  const markRequestSubmitted = (isInstantBlock) => {
    if (isInstantBlock) {
      setIsBlocked(true);
    } else {
      setIsPending(true);
    }
  };

  return {
    isBlocked,
    isPending,
    canRequestBlock: !isBlocked && !isPending,
    markRequestSubmitted,
  };
}
